import React, {ReactNode} from 'react'
import styled from 'styled-components'
import {fontSmall} from '../library/css'
import {Switch} from '../library/switch'
import {Fields} from '.'
import {
  Tooltip,
  TooltipPosition
} from '../../../../components/library/tooltip/tooltip'
import SVGInformationSmall from '../../../../assets/icons/information-small.svg'

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 20px;
  .tooltip a, // content within tooltips
  > * {
    // and immediate children
    // should be aligned center
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  h3 {
    gap: 8px;
    margin: 0px;
    color: ${({theme}) => theme.colors.grey12};
    ${fontSmall}
    font-weight: 700;
  }
`

const TooltipWrapper = styled.div`
  display: flex;
  align-items: center;

  .action-flow-section-tooltip > div {
    max-width: 220px;
    min-width: 220px;
    text-align: left;
    white-space: normal;
  }
`

const Description = styled.div`
  ${fontSmall}
`

export const Section = ({
  title,
  description,
  tooltip,
  isOpen,
  setOpen,
  children,
  readOnly,
  tooltipPosition = 'right'
}: {
  title: ReactNode
  description?: ReactNode
  tooltip?: string
  tooltipPosition?: TooltipPosition
  isOpen?: boolean
  setOpen?: (open: boolean) => void
  children: ReactNode
  readOnly?: boolean
}) => {
  const withReveal = typeof isOpen === 'boolean'
  const header = (
    <Header>
      <h3>{title}</h3>
      {withReveal ? (
        <Switch readOnly={readOnly} onChange={setOpen} checked={isOpen} />
      ) : null}
    </Header>
  )
  return (
    <Fields>
      {tooltip ? (
        <TooltipWrapper>
          {header}
          <Tooltip
            content={tooltip}
            position={tooltipPosition}
            className="action-flow-section-tooltip"
          >
            <SVGInformationSmall
              style={{
                marginLeft: '8px',
                marginTop: '2px',
                color: 'var(--color-grey-10)'
              }}
            />
          </Tooltip>
        </TooltipWrapper>
      ) : (
        header
      )}
      {description ? <Description>{description}</Description> : null}
      {withReveal ? (isOpen ? children : null) : children}
    </Fields>
  )
}
